export function Steps({ steps = [] }) {
  if (steps.length === 0) return null;

  return (
    <div className="steps">
      {steps.map((step) => (
        <p className="steps__step" key={step}>
          {step}
        </p>
      ))}
    </div>
  );
}
